import { RESET_STATE } from '@/store/mutation-type';
import getAll from '@/api/logistique/demande/index';
import * as apiDemandeLogistique from '@/api/logistique/demandeLogistique/index';
import * as genererCritereRecherche from '@/services/logistique/demande/genererCritereRechercheDemande';
import genererDateSelect from '@/services/logistique/demande/genererDateSelect';
import * as types from './demande-mutation-type';

function initialState() {
  return {
    demande: {
      ligneCommandes: [],
      quantiteFacesAAffecter: 0,
      quantiteFacesVendues: 0,
      quantiteFacesAffectees: 0,
    },
    demandesLogistiques: null,
    criteresRecherche: genererCritereRecherche.genererCritereRechercheDemande(),
    criteresRechercheLogistique: genererCritereRecherche
      .genererCritereRechercheDemandesLogistiques(),
    dateSelect: genererDateSelect(),
    lastPayload: {},
    lastPayloadLogistique: {},
    total: 0,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_DEMANDE](state, demande) {
    state.demande = demande;
  },
  [types.SET_DEMANDE_LOGISTIQUE](state, demandesLogistiques) {
    state.demandesLogistiques = demandesLogistiques;
  },
  [types.SET_CRITERE](state, critere) {
    state.criteresRecherche = critere;
  },
  [types.SET_CRITERE_LOGISTIQUE](state, critere) {
    state.criteresRechercheLogistique = critere;
  },
  [types.SET_DATE_SELECT](state, dateSelect) {
    state.dateSelect = dateSelect;
  },
  [RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_LAST_PAYLOAD_LOGISTIQUE](state, payload) {
    state.lastPayloadLogistique = payload;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
};

const actions = {
  async loadDemande({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD, data);
    const response = (await getAll(data)).data.result;
    let quantiteFacesVendues = 0;
    let quantiteFacesAffectees = 0;
    let quantiteFacesAAffecter = 0;
    response.items.forEach((ligne) => {
      ligne.selected = false;
      let aAffecter = 0;
      quantiteFacesVendues += ligne.facesVendues ? ligne.facesVendues : 0;
      quantiteFacesAffectees += ligne.facesAffectees ? ligne.facesAffectees : 0;
      aAffecter = ligne.facesVendues - ligne.facesAffectees;
      if (aAffecter < 0) aAffecter = 0;
      quantiteFacesAAffecter += aAffecter;
    });
    const donnees = {
      ligneCommandes: response.items,
      quantiteFacesAAffecter: quantiteFacesAAffecter,
      quantiteFacesVendues: quantiteFacesVendues,
      quantiteFacesAffectees: quantiteFacesAffectees,
    };
    commit(types.SET_DEMANDE, donnees);
    commit(types.SET_TOTAL, response.totalCount);
  },
  async loadDemandesLogistiques({ commit }, data) {
    commit(types.SET_LAST_PAYLOAD_LOGISTIQUE, data);
    const demandes = (await apiDemandeLogistique.getAll(data))
      .data.result.items;
    demandes.forEach((demande) => {
      demande.selected = false;
    });
    commit(types.SET_DEMANDE_LOGISTIQUE, demandes);
  },
};

const getters = {
  demande: state => {
    return state.demande;
  },
  demandesLogistiques: state => {
    return state.demandesLogistiques;
  },
  criteresRecherche: state => {
    return state.criteresRecherche;
  },
  criteresRechercheLogistique: state => {
    return state.criteresRechercheLogistique;
  },
  dateSelect: state => {
    return state.dateSelect;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  lastPayloadLogistique: state => {
    return state.lastPayloadLogistique;
  },
  total: state => {
    return state.total;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
